import React, { useEffect, useRef } from 'react';
import ChatIcon from './ChatIcon';

export default function ChatComposer({ value, onChange, onSubmit, isSending, error }) {
  const fieldRef = useRef(null);
  const wasSending = useRef(false);
  useEffect(() => {
    const field = fieldRef.current;
    field.style.height = 'auto';
    field.style.height = `${Math.min(field.scrollHeight || 28, 160)}px`;
  }, [value]);
  useEffect(() => {
    if (wasSending.current && !isSending) fieldRef.current?.focus({ preventScroll: true });
    wasSending.current = isSending;
  }, [isSending]);

  return (
    <div className="chat-composer-wrap">
      {error && <div className="chat-error" role="alert">{error}</div>}
      <form className="chat-composer" onSubmit={onSubmit}>
        <textarea
          ref={fieldRef} rows={1} aria-label="Mensaje" value={value}
          onChange={(event) => onChange(event.target.value)} disabled={isSending} maxLength={4000}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) {
              event.preventDefault();
              onSubmit(event);
            }
          }}
        />
        <button className="chat-send" type="submit" disabled={isSending || !value.trim()} aria-label="Consultar" title="Consultar">
          {isSending ? <span className="chat-send-spinner" /> : <ChatIcon name="arrow" />}
        </button>
      </form>
    </div>
  );
}
